import { render, staticRenderFns } from "./culture-restitution.vue?vue&type=template&id=948be520&scoped=true"
import script from "./culture-restitution.vue?vue&type=script&lang=js"
export * from "./culture-restitution.vue?vue&type=script&lang=js"
import style0 from "./culture-restitution.vue?vue&type=style&index=0&id=948be520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948be520",
  null
  
)

export default component.exports